// src/constants/farmMarkConstants.js

/**
 * FarmMark configuration constants.
 * All Impact Point (IP) rules and gamification thresholds live here.
 * Centralized to ensure Leaderboard, My Impact, and service layer stay in sync.
 */

// Impact Points awarded per qualifying action
export const IP_PER_PRODUCT_LISTING = 5;
export const IP_PER_VALIDATED_PRICE_REPORT = 10;
export const IP_PER_PLANTING_REPORT = 0;

// CO2 estimation factor: kg CO2 saved per kg of food sold (instead of wasted).
// Based on EPA / WRAP estimates: ~2.5 kg CO2e per kg of food waste avoided (production + landfill methane).
// This is intentionally conservative and easy to adjust.
export const CO2_KG_PER_KG_FOOD_SOLD = 2.5;

// Equivalence factors for visualization
export const CO2_KG_PER_TREE_PER_YEAR = 21; // avg tree absorbs ~21 kg CO2/year
export const CO2_KG_PER_CAR_KM = 0.21; // avg car emits ~0.21 kg CO2/km
export const AVG_MEAL_WEIGHT_KG = 0.4; // average meal weight for "meals rescued" count

// Leaderboard defaults
export const LEADERBOARD_PAGE_SIZE = 20;

// Time range filter options (in days, null = all time)
export const TIME_RANGES = {
  WEEK: 7,
  MONTH: 30,
  ALL_TIME: null,
};

// Firestore field names used for IP tracking on user documents
export const USER_FIELDS = {
  POINTS: "points",
  PRODUCTS_LISTED: "productsListed",
  PRICES_SUBMITTED: "pricesSubmitted",
  CO2_SAVED: "co2Saved",
};

// Impact feed event types
export const IMPACT_TYPES = {
  CLAIM: "claim",
  RATING: "rating",
  PRICE_CONTRIBUTION: "price_contribution",
  PLANTING: "planting_intention",
  PRODUCT_LISTING: "product_listing",
};
